export default "__VITE_ASSET__CTNGicg1__"